import { GenericAbortSignal } from 'axios';

import { Library, LibraryKind } from '../types/Library';
import { Project, VideoInfo } from '../types/Project';
import { LIBRARY_API_URL } from './constants';
import { get, post } from './requestMethods';

const LANDING_API_URL = 'https://preproducts.rask.ai';

export type UploadVideoByLinkRequestData = {
  kind?: LibraryKind;
  link: string;
};

export type LandingMediaResponse = {
  url: string;
};

const fetchLandingMedia = async (mediaId: string): Promise<LandingMediaResponse> => {
  const response = await fetch(`${LANDING_API_URL}/media/${mediaId}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch landing media: ${response.status}`);
  }

  return response.json();
};

export const LIBRARY_CALLS_API = {
  // Upload media by source URL
  uploadVideoByLink: (data: UploadVideoByLinkRequestData) => post<Library>(`${LIBRARY_API_URL}/media/link`, { data }),

  // Get media URL from landing backend
  getLandingMedia: fetchLandingMedia,

  // Get media file status by ID
  getLinkedMediaUploadStatus: (mediaId: string, signal?: GenericAbortSignal) =>
    get<Library>(`${LIBRARY_API_URL}/media/${mediaId}`, { signal }),

  // Get video metadata when uploading videos from Youtube
  getVideoInfo: (data: { url: Project['source_url'] }, signal?: GenericAbortSignal) =>
    get<VideoInfo>(`${LIBRARY_API_URL}/info/video?link=${data.url}`, { signal }),
};
